import { render, staticRenderFns } from "./CallComponent.vue?vue&type=template&id=fc2cb5f6&scoped=true&"
import script from "./CallComponent.vue?vue&type=script&lang=js&"
export * from "./CallComponent.vue?vue&type=script&lang=js&"
import style0 from "./CallComponent.vue?vue&type=style&index=0&id=fc2cb5f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2cb5f6",
  null
  
)

export default component.exports